import { useEffect } from "react";

import { injectGlobal } from "@emotion/css";
import { usePostHog } from "posthog-js/react";

import { useTheme } from "@/theme/CreateTheme.ts";
import { ScreenMax } from "@/theme/responsive.ts";

export const useReleaseNotesBanner = () => {
  const theme = useTheme();
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog.featureFlags.isFeatureEnabled("release-notes")) {
      // Only show release notes banner once auth has been passed
      injectGlobal`
      #release-notes-container {
        display: block !important;
        position: fixed;
        bottom: 0;
        right: 0;
        height: fit-content;
        width: calc(100% - ${theme.spacing(30)});

        ${ScreenMax.SM} {
          top: 0;
          width: 100vw;
        }
      }
    `;
    }
  }, [posthog, theme]);
};
